"use client";
import React from "react";
import { Picture } from "@/app/components/form/picture";
import data from "/data/data.json";

export default function Error({ error }) {
  return (
    <div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div style={{ width: "30rem", height: "35rem" }}>
          <center>
            <Picture
              path={`/img/${data[process.env.NEXT_PUBLIC_APP_NAME].logo}`}
              height={300}
              alt={"logo"}
            />
            <h3>Oh, no!...... Something went wrong!</h3>
            <p>{error.message}</p>
          </center>
        </div>
      </div>
    </div>
  );
}
